<template>
   <div class="child">
      <div class="field">
         <label class="label">Etunimi</label>
         <div class="control">
            <input class="input" type="text" name="firstname" v-model="storeState.child.firstname" v-validate="'required'" />
         </div>
      </div>

      <div class="field">
         <label class="label">Sukunimi</label>
         <div class="control">
            <input class="input" type="text" name="lastname" v-model="storeState.child.lastname" v-validate="'required'" />
         </div>
      </div>

      <div class="field">
         <label class="label">Osoite</label>
         <div class="control">
            <input v-validate="'required'" class="input" type="text" v-model="storeState.child.address.street" />
         </div>
      </div>

      <div class="field">
         <label class="label">Postinumero</label>
         <div class="control">
            <input v-validate="'required|numeric|min_value:00000|max_value:99999|max:5'" class="input" v-on:input="processZip(storeState.child.address.zip)" type="text" v-model="storeState.child.address.zip" />
         </div>
      </div>

      <div class="field">
         <label class="label">Kaupunki</label>
         <div class="control">
            <input class="input" placeholder="Täytetään automaattisesti" type="text" disabled="disabled" v-model="storeState.child.address.city" />
         </div>
      </div>

      <div class="field">
         <label class="label">Lapsen koulu ja luokka</label>
         <div class="control">
            <input class="input" type="text" v-model="storeState.child.schoolAndClass" />
         </div>
      </div>

      <div class="field">
         <label class="label">Kaveritoiveet</label>
         <div class="control">
            <input class="input" type="text" v-model="storeState.child.friends" />
         </div>
      </div>

      <div class="field">
         <label class="label">Allergia ja lääkitys</label>
         <div class="control">
            <input class="input" type="text" v-model="storeState.child.allergies" />
         </div>
      </div>

      <div class="field">
         <label class="label">Erityistoiveet tai erityistarpeet</label>
         <div class="control">
            <input class="input" type="text" v-model="storeState.child.specialNeeds" />
         </div>
      </div>

      <div class="field">
         <label class="label">Koulutaksilla kulkeminen</label>
         <div class="control">
            <button class="btn-terms" v-bind:class="{'approved': storeState.child.schoolRide}" @click="store.toggleSchoolRide()" type="button">Lapsi kulkee koulutaksilla</button>
         </div>
      </div>

      <div v-if="storeState.child.schoolRide" class="field">
         <label class="label">Saapumisaika koulutaksilla iltapäiväkerhoon</label>
         <div class="control">
            <input class="input" type="text" placeholder="kellonaika esim. 13.30" v-model="storeState.child.rideArrival" />
         </div>
      </div>

      <div v-if="storeState.child.schoolRide" class="field">
         <label class="label">Lähtemisaika koulutaksilla iltapäiväkerhosta</label>
         <div class="control">
            <input class="input" type="text" placeholder="kellonaika esim. 16:00" v-model="storeState.child.rideDeparture" />
         </div>
      </div>

      <div class="field">
         <label class="label">Annan luvan lähettää tietoa lapsesta koulun ja iltapäivätoiminnan välillä</label>
         <div class="control">
            <button class="btn-terms" v-bind:class="{'approved': storeState.child.dataPassRequest}" @click="store.approveDataPass()" type="button">Annan tietojenvälitysluvan</button>
         </div>
      </div>

      <div class="field">
         <label class="label">Lapsestani saa ottaa kuvia iltapäiväkerhotoiminnan käyttöön</label>
         <div class="control">
            <button class="btn-terms" v-bind:class="{'approved': storeState.child.photographyRequest}" @click="store.approvePhotography()" type="button">Annan kuvausluvan</button>
         </div>
      </div>

   </div>
</template>

<script>
import zipService from '../services/zipcode.js'

export default {
   name: 'child',

   props: ['store'],

   components: {
   },

   data () {
      return {
         storeState: this.store.state
      }
   },

   methods: {
      processZip (zip) {
         this.storeState.child.address.city = zipService.getMunicipality(zip)
      }
   }
}
</script>

<style scoped>
.display-inline {
   display: inline-block;
}

.btn-terms {
   @apply max-w-md;
   @apply bg-gray-300;
   @apply border border-solid border-gray-500;
   @apply rounded;
   @apply py-3 px-3;
   @apply text-left;
}

.btn-terms.approved {
   @apply border-pilke-primary;
   @apply text-white;
   @apply bg-pilke-primary;
   @apply pl-12;
   background-image: url('../assets/checkmark.png');
   background-repeat: no-repeat;
   background-position: left 13px center;
}
</style>
